import { outreachEventTypes } from "@redotech/redo-customer-event-common/customer-event-definition";
import { outreachEventScopes } from "@redotech/redo-marketing-outreach-common/outreach";
import * as z from "zod";

const scopeSchema = z.enum(outreachEventScopes);

/** One event type's count per group and the people behind it. The filter needs a campaign, automation
 *  or template, and grouping by recipient needs a recipient filter. */
export const countOutreachEvents = {
  name: "countOutreachEvents" as const,
  input: z.object({
    eventType: z.enum(outreachEventTypes),
    scopes: z.array(scopeSchema),
    filter: z.partialRecord(scopeSchema, z.array(z.string()).min(1).max(200)),
  }),
  output: z.object({
    rows: z.array(
      z.object({
        groupBy: z.partialRecord(scopeSchema, z.string().nullable()),
        count: z.number(),
        customers: z.number(),
      }),
    ),
  }),
};
